import * as types from "./constant"

const initialState = {
  Loading: false,
  PolicyTypeAdded: false,
  PolicyCustm: false,
  viewPolicyType: [],
  AdditionalFields: [],
  PolicyForCustomer: [],
  PolicyUpdate: false,
  isLinking: false,
  EnumValue: [],
  STATE: [],
  REGISTATION_NUMBER: [],
  BRANDNAME: [],
  MODEL_NAME: [],
  companyName: [],
  isBharatReg: false,
  ProductName: [],
  PolicyName: [],
  PolicyNumber: "",
  VehicleAdded: false,
  subPolicy: [],
  isNcb: [],
  subLob: [],
  gst_rates: [],
  PolicyById: [],
  error: null,
  policyMsg: "",
  customerPolcy: [],
  policyReports: [],
  ReportsTotalData: {},
  references: [],
  isDelete: false,
  autoFillData: null,
  autoFillError: null,
  irdaPolicyReportLoading: false,

  // ---- policy files ----
  uploadedPolicyFiles: [],
  deletePolicyFile: false,
  isUploading: false,

  MovePolicyLoading: false,
  MovePolicySuccess: false,
  MovePolicyMessage: "",

  policyReportStatus: {
    loading: false,
    isRequested: false,
    requestId: null,
    file: null,
    requestStatus: null,
    message: null,
    error: null
  },
  allPolicyReports: [],
  commissionPermisstion: {
    "canEditCommission": false,
    "canViewCommission": false
  }
}

const PolicyReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_POLICY_TYPE_START:
    case types.GET_POLICY_CUSTOMER_START:
    case types.ADD_POLICY_START:
    case types.GET_POLICY_CUSTOMER_ID_START:
    case types.POLICY_LINKING_START:
      return {
        ...state,
        Loading: true,
        error: null,
        policyMsg: "",
        PolicyById: [],
        PolicyForCustomer: [],
      }

    case types.DELETE_POLICY_SUCCESS:
      return {
        ...state,
        isDelete: true,
      }

    case types.DELETE_POLICY_RESET:
      return {
        ...state,
        isDelete: false,
      }
    case types.CHECK_POLICY_NUMBER_SUCCESS: {
      const payload = action.payload || {}

      // This endpoint now answers 200 for BOTH outcomes — "Duplicate Policy
      // Number" and "Policy number available" — and the message is rendered in
      // a red alert. Only the duplicate is worth showing; good news in danger
      // styling reads as a failure and had users thinking something was wrong.
      //
      // `duplicate` is the reliable signal. Falling back to `status` keeps this
      // correct against a backend that predates that field.
      const isDuplicate =
        payload.duplicate === undefined
          ? payload.status === 1
          : !!payload.duplicate

      return {
        ...state,
        PolicyNumber: isDuplicate ? payload.message : "",
      }
    }

    case types.CHECK_POLICY_NUMBER_FAIL:
      return {
        ...state,
        PolicyNumber: action.payload.error,
      }

    case types.CHECK_POLICY_NUMBER_RESET:
      return {
        ...state,
        PolicyNumber: "",
      }

    case types.ADD_MAKE_MODEL_SUCCESS:
      return {
        ...state,
        VehicleAdded: true,
      }

    case types.ADD_MAKE_MODEL_FAILURE:
      return {
        ...state,
        VehicleAdded: false,
      }

    case types.ADD_MAKE_MODEL_RESET:
      return {
        ...state,
        VehicleAdded: false,
      }

    case types.GET_POLICY_CUSTOMER_ID_RESET:
      return {
        ...state,
        PolicyById: [],
      }
    // STATE
    case types.GET_STATE_SUCCESS:
      return {
        ...state,
        STATE: action.payload,
      }
    case types.GET_STATE_FAILURE:
      return {
        ...state,
        STATE: action.payload.error,
      }

    case types.GET_STATE_RESET:
      return {
        ...state,
        STATE: [],
      }

    // REG Number
    case types.GET_REG_SUCCESS:
      return {
        ...state,
        REGISTATION_NUMBER: action.payload,
      }
    case types.GET_REG_FAILURE:
      return {
        ...state,
        REGISTATION_NUMBER: action.payload.error,
      }

    case types.RESET_BHARAT_REG_NCB: {
      return {
        ...state,
        isBharatReg: false,
        isNcb: [],
      }
    }

    case types.GET_REG_RESET:
      return {
        ...state,
        REGISTATION_NUMBER: [],
      }

    case types.GET_BRAND_SUCCESS:
      return {
        ...state,
        BRANDNAME: action.payload,
      }
    case types.GET_BRAND_FAILURE:
      return {
        ...state,
        BRANDNAME: action.payload.error,
      }

    case types.GET_BRAND_RESET:
      return {
        ...state,
        BRANDNAME: [],
      }

    case types.GET_MODEL_SUCCESS:
      return {
        ...state,
        MODEL_NAME: action.payload,
      }
    case types.GET_MODEL_FAILURE:
      return {
        ...state,
        MODEL_NAME: action.payload.error,
      }

    case types.GET_MODEL_RESET:
      return {
        ...state,
        MODEL_NAME: [],
      }

    // Bharat_number and ncb field
    case types.SET_IS_BHARAT_REG:
      return {
        ...state,
        isBharatReg: action.payload,
      }

    case types.SET_IS_NCB:
      return {
        ...state,
        isNcb: action.payload,
      }

    case types.ADD_POLICY_TYPE_SUCCESS:
      return {
        ...state,
        Loading: false,
        PolicyTypeAdded: true,
      }

    case types.GET_ENUM_VALUE: {
      return { ...state, EnumValue: action.payload }
    }
    case types.RESET_ENUM_VALUE: {
      return { ...state, EnumValue: [] }
    }

    case types.GetAdditionalLOB_SUCCESS:
      return {
        ...state,
        AdditionalFields: action.payload,
      }

    case types.GetAdditionalLOB_RESET:
      return {
        ...state,
        AdditionalFields: [],
      }

    case types.GET_RRODUCT_SUCCESS:
      return {
        ...state,
        ProductName: action.payload,
      }
    case types.GET_RRODUCT_FAILURE:
      return {
        ...state,
        ProductName: action.payload.error,
      }
    case types.GET_RRODUCT_RESET:
      return {
        ...state,
        ProductName: [],
      }
    case types.POLICY_LINKING_SUCCESS:
      return {
        ...state,
        Loading: false,
        isLinking: true,
      }

    case types.POLICY_LINKING_RESET:
      return {
        ...state,
        isLinking: false,
      }

    case types.POLICY_LINKING_FAILURE:
      return {
        ...state,
        isLinking: false,
        Loading: false,
      }

    case types.GET_POLICY_CUSTOMER_SUCCESS:
      return {
        ...state,
        Loading: false,
        PolicyForCustomer: action.payload,
      }
    case types.ADD_POLICY_SUCCESS:
      return {
        ...state,
        Loading: false,
        PolicyTypeAdded: true,
        PolicyCustm: true,
      }

    case types.ADD_POLICY_RESET: {
      return {
        ...state,
        Loading: false,
        PolicyCustm: false,
        PolicyTypeAdded: false,
      }
    }
    case types.ADD_POLICY_TYPE_FAILURE:
    case types.ADD_POLICY_FAILURE:
    case types.VIEW_POLICY_TYPE_FAILURE:
    case types.GET_POLICY_CUSTOMER_ID_FAILURE:
      console.log(action.payload)
      return {
        ...state,
        Loading: false,
        policyMsg: action.payload,
      }
    case types.GET_POLICY_CUSTOMER_FAILURE:
      return {
        ...state,
        Loading: false,
        policyMsg: action.payload.message,
        PolicyForCustomer: []
      }

    case types.ADD_POLICY_TYPE_RESET:

    case types.VIEW_POLICY_TYPE_SUCCESS:
      return {
        ...state,
        viewPolicyType: action.payload,
      }

    case types.GET_GST_SUCCESS:
      return {
        ...state,
        gst_rates: action.payload,
      }

    case types.GET_POLICY_CUSTOMER_ID_SUCCESS: {
      return {
        ...state,
        Loading: false,
        PolicyById: action.payload,
      }
    }

    case types.UPDATE_POLICY_START:
      return {
        ...state,
        Loading: true,
        PolicyUpdate: false,
        policyMsg: action.payload.message,
      }
    case types.UPDATE_POLICY_SUCCESS:
      return {
        ...state,
        Loading: false,
        // policyMsg: action.payload.message,
        PolicyUpdate: true,
      }
    case types.UPDATE_POLICY_FAILURE:
      return {
        ...state,
        Loading: false,
        PolicyUpdate: false,
        policyMsg: action.payload.message,
      }
    case types.UPDATE_POLICY_RESET:
      return {
        ...state,
        Loading: false,
        PolicyTypeAdded: false,
        PolicyCustm: false,
        PolicyUpdate: false,
      }

    case types.GET_Company_START:
    case types.GET_POLICY_START:
    case types.GET_SUB_POLICY_START:
      return {
        ...state,
      }

    case types.GET_Company_SUCCESS:
      return {
        ...state,
        companyName: action.payload,
      }
    case types.GET_POLICY_SUCCESS:
      return {
        ...state,
        PolicyName: action.payload,
      }
    case types.GET_SUB_POLICY_SUCCESS:
      return {
        ...state,
        subPolicy: action.payload,
      }

    case types.GET_SUB_LOB_SUCCESS:
      return {
        ...state,
        subLob: action.payload,
      }

    // ---------------------------------------------------------
    //                POLICY FILES (FIXED CONSTANTS)
    // ---------------------------------------------------------

    // Upload
    case types.UPLOAD_POLICY_FILE_START:
      return {
        ...state,
        Loading: true,
        error: null,
        policyMsg: null,
        isUploading: false,
      }
    case types.UPLOAD_POLICY_FILE_SUCCESS:
      return {
        ...state,
        Loading: false,
        policyMsg: action.payload,
        isUploading: true,
      }
    case types.UPLOAD_POLICY_FILE_FAIL:
      return {
        ...state,
        Loading: false,
        isUploading: false,
        error: action.payload,
      }

    // List/View
    case types.GET_UPLOADED_POLICY_FILE_START:
      return {
        ...state,
        Loading: true,
        error: null,
        policyMsg: null,
        uploadedPolicyFiles: [],
      }
    case types.GET_UPLOADED_POLICY_FILE_SUCCESS:
      return {
        ...state,
        Loading: false,
        uploadedPolicyFiles: action.payload,
      }
    case types.GET_UPLOADED_POLICY_FILE_FAILURE:
      return {
        ...state,
        Loading: false,
        error: action.payload,
      }
    case types.GET_UPLOADED_POLICY_FILE_RESET:
      return {
        ...state,
        Loading: false,
        error: null,
        policyMsg: null,
      }

    // Edit filename
    case types.EDIT_POLICY_FILES:
      return {
        ...state,
        Loading: true,
        policyMsg: "",
        error: null,
      }
    case types.EDIT_POLICY_FILES_SUCCESS:
      return {
        ...state,
        Loading: false,
        policyMsg: "File Edited SuccessFully",
      }
    case types.EDIT_POLICY_FILES_FAILED:
      return {
        ...state,
        Loading: false,
        error: "unable to EDIT file, please try again",
      }

    // Delete
    case types.DELETE_POLICY_FILE_START:
      return {
        ...state,
        Loading: true,
        deletePolicyFile: true,
      }
    case types.DELETE_POLICY_FILE_SUCCESS:
      return {
        ...state,
        Loading: false,
        deletePolicyFile: true,
      }
    case types.DELETE_POLICY_FILE_FAILURE:
      return {
        ...state,
        Loading: false,
        deletePolicyFile: false,
      }
    case types.DELETE_POLICY_FILE_RESET:
      return {
        ...state,
        Loading: false,
        deletePolicyFile: false,
      }

    // ---------------------------------------------------------

    case types.GET_Company_FAILURE:
    case types.GET_POLICY_FAILURE:
    case types.GET_SUB_POLICY_FAILURE:
    case types.GET_SUB_LOB_FAILURE:
      return {
        ...state,
        companyName: action.payload,
        PolicyName: action.payload,
        subPolicy: action.payload,
        subLob: action.payload,
      }
    case types.GET_Company_RESET:
    case types.GET_POLICY_RESET:
    case types.GET_SUB_POLICY_RESET:
    case types.GET_SUB_LOB_RESET:
      return {
        ...state,
        companyName: [],
        PolicyName: [],
        subPolicy: [],
        subLob: [],
      }
    case types.GET_POLICYREPORT_START:
      return {
        ...state,
        Loading: true,
        error: "",
        policyReports: []
      }
    case types.GET_POLICYREPORT_SUCCESS:
      return {
        ...state,
        Loading: false,
        policyReports: action?.payload?.data || [],
        ReportsTotalData: action?.payload?.TotalData || {}
      }
    case types.GET_POLICYREPORT_FAIL:
      return {
        ...state,
        Loading: false,
        error: action.payload,
      }
    case types.GET_REFERENCES_START:
      return {
        ...state,
        Loading: true,
      }
    case types.GET_REFERENCES_SUCCESS:
      return {
        ...state,
        Loading: false,
        references: action.payload,
      }
    case types.GET_REFERENCES_FAIL:
      return {
        ...state,
        Loading: false,
        error: action.payload,
      }
    case types.POLICY_ERROR_RESET:
      return {
        ...state,
        error: false,
        Loading: false,
      }

    case types.REQ_POLICY_REPORT:
      return {
        ...state,
        policyReportStatus: {
          ...state.policyReportStatus,
          loading: true,
          isRequested: false,
          requestId: null
        }
      }

    case types.REQ_POLICY_REPORT_SUCCESS:
      return {
        ...state,
        policyReportStatus: {
          ...state.policyReportStatus,
          message: "Policy report generating started, please Check in Download icon",
          loading: false,
          isRequested: true,
          requestId: action.payload
        }
      }

    case types.REQ_POLICY_REPORT_FAILED:
      return {
        ...state,
        policyReportStatus: {
          ...state.policyReportStatus,
          error: "Failed to generate policy report, Please try again",
          loading: false,
          isRequested: false,
        }
      }

    case types.POLICY_REPORT_STATUS:
      return {
        ...state,
        policyReportStatus: {
          ...state.policyReportStatus,
          loading: true,
        }
      }
    case types.POLICY_REPORT_STATUS_SUCCESS:
      return {
        ...state,
        policyReportStatus: {
          ...state.policyReportStatus,
          loading: false,
          requestStatus: action.payload,
        }
      }

    case types.POLICY_REPORT_STATUS_FAILED:
      return {
        ...state,
        policyReportStatus: {
          ...state.policyReportStatus,
          loading: false,
          isRequested: false,
          requestStatus: "Failed",
        }
      }

    case types.DOWNLOAD_POLICY_REPORT:
      return {
        ...state,
        policyReportStatus: {
          ...state.policyReportStatus,
          loading: true,
        }
      }
    case types.DOWNLOAD_POLICY_REPORT_SUCCESS:
      return {
        ...state,
        policyReportStatus: {
          ...state.policyReportStatus,
          loading: false,
          isRequested: false,
          requestId: null,
          file: action.payload,
          requestStatus: null,
          message: null,
          error: null
        }
      }
    case types.DOWNLOAD_POLICY_REPORT_FAILED:
      return {
        ...state,
        policyReportStatus: {
          ...state.policyReportStatus,
          loading: false,
          isRequested: false,
          requestId: null,
          file: null,
          requestStatus: null,
          message: null,
          error: null
        }
      }
    case types.RESET_POLICY_REPORT_DOWNLOAD:
      return {
        ...state,
        policyReportStatus: {
          ...state.policyReportStatus,
          loading: false,
          isRequested: false,
          requestId: null,
          file: null,
          requestStatus: null,
          message: null,
          error: null
        }
      }

    case types.GET_ALL_POLICY_REPORTS:
      return {
        ...state,
        loading: true,
        policyReportStatus: {
          ...state.policyReportStatus,
          requestStatus: null,
          message: null,
          error: null
        }
      }

    case types.GET_ALL_POLICY_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        allPolicyReports: action.payload
      }

    case types.GET_ALL_POLICY_REPORTS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case types.GET_COMMISSION_PERMISSION:
      return {
        ...state,
        loading: true
      }

    case types.GET_COMMISSION_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        commissionPermisstion: action.payload
      }

    case types.GET_COMMISSION_PERMISSION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

      case types.UPLOAD_POLICY_PDF_START:
        return {
          ...state,
          Loading: true,
          error: null
        }

      case types.UPLOAD_POLICY_PDF_SUCCESS:
        return {
          ...state,
          Loading: false,
          policyMsg: action.payload?.message || "File uploaded successfully"
        }

      case types.UPLOAD_POLICY_PDF_ERROR:
        return {
          ...state,
          Loading: false,
          error: action.payload
        }

      case types.UPLOAD_POLICY_PDF_RESET:
        return {
          ...state,
          error: null,
          policyMsg: ""
        }
      case types.AUTO_FILL_START:
        return {
          ...state,
          Loading: true,
          autoFillData: null,
          autoFillError: null
        }

      case types.AUTO_FILL_SUCCESS:
        return {
          ...state,
          Loading: false,
          autoFillData: action.payload,
          autoFillError: null
        }

      case types.AUTO_FILL_FAIL:
        return {
          ...state,
          Loading: false,
          error: action.payload,
          // `error` is shared by many policy actions, so auto-fill keeps its own
          // key — otherwise the form cannot tell whose failure it is showing.
          autoFillError: action.payload
        }

      case types.REQ_IRDA_POLICY_REPORT:
        return {
          ...state,
          irdaPolicyReportLoading: true
        };

      case types.REQ_IRDA_POLICY_REPORT_SUCCESS:
        return {
          ...state,
          irdaPolicyReportLoading: false
        };

      case types.REQ_IRDA_POLICY_REPORT_FAIL:
        return {
          ...state,
          irdaPolicyReportLoading: false
        };

      case types.MOVE_POLICY_STAGING_START:
        return {
            ...state,
            MovePolicyLoading: true
        };

      case types.MOVE_POLICY_STAGING_SUCCESS:
        return {
            ...state,
            MovePolicyLoading: false,
            MovePolicySuccess: true,
            MovePolicyMessage: action.payload.message
        };

      case types.MOVE_POLICY_STAGING_ERROR:
        return {
            ...state,
            MovePolicyLoading: false,
            MovePolicySuccess: false,
            MovePolicyMessage: action.payload
        };

      case types.MOVE_POLICY_STAGING_RESET:
        return {
            ...state,
            MovePolicyLoading: false,
            MovePolicySuccess: false,
            MovePolicyMessage: ""
        };

    default:
      return state
  }
}

export default PolicyReducer
